const summaryVideos = {
  videos: ['https://s3-eu-west-1.amazonaws.com/online-sessions/44652422/c33c099a-2175-480a-becc-725460d8ef62/archive.mp4'],
};

// archiveId 'c33c099a-2175-480a-becc-725460d8ef62'
// transform to - 'https://s3-eu-west-1.amazonaws.com/online-sessions/44652422/c33c099a-2175-480a-becc-725460d8ef62/archive.mp4';
export default summaryVideos;
